import { message } from "antd";
import { domainUrl } from "../../constants";

const submitContactFormApi = (raw) => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(raw),
        redirect: 'follow',
    };
    const url = '/contactUs';
    return (
        fetch(domainUrl + url, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success(result?.message);
                return 1;
            } else {
                message.error(result?.message);
                return 0;
            }
        })
        .catch(error => {
            message.error(error.message);
            return 0;
        })
    )
};

const contactFormApi = {
    submitContactFormApi,
};

export { contactFormApi };
